import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { "aria-label": "breadcrumb" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "fa fa-home mr-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Home ")
const _hoisted_6 = { href: "javascript:void(0)" }
const _hoisted_7 = /*#__PURE__*/_createVNode("li", {
  class: "breadcrumb-item active",
  "aria-current": "page"
}, "Invoice", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    _createVNode("ol", _hoisted_2, [
      _createVNode("li", _hoisted_3, [
        _createVNode(_component_router_link, { to: { name: 'admin-dashboard' } }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.breadcrumbList, (item, itemIndex) => {
        return (_openBlock(), _createBlock("li", {
          class: "breadcrumb-item",
          key: itemIndex,
          onClick: ($event: any) => (_ctx.redirectToSelected(itemIndex, item.uuid))
        }, [
          _createVNode("a", _hoisted_6, _toDisplayString(item.name), 1)
        ], 8, ["onClick"]))
      }), 128)),
      _hoisted_7
    ])
  ]))
}